import { render, staticRenderFns } from "./proveMethod.vue?vue&type=template&id=46812370&scoped=true&"
import script from "./proveMethod.vue?vue&type=script&lang=js&"
export * from "./proveMethod.vue?vue&type=script&lang=js&"
import style0 from "./proveMethod.vue?vue&type=style&index=0&id=46812370&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46812370",
  null
  
)

export default component.exports